import React, {Fragment, useEffect} from 'react';
import M from 'materialize-css';

import GaleriaCAAV from '../../Components/Galerias/CAAV';
import Desktop from '../../Components/Desktop';

import caav1 from '../../Images/Proyectos/caav.png';
import caav2 from '../../Images/Proyectos/Galerias/CAAV/10.png';



const CAAV = () => {
    
    useEffect(() => {
      var elems = document.querySelectorAll('.sidenav');
      M.Sidenav.init(elems);
    });


    return (
      <Fragment>        
        <img className="center-img dimensionar-imagen-movil" alt="" src={caav1}></img>

        <div className='container'>
          {window.screen.width >= 993 ? (
            <p className='texto' style={{textAlign:"center"}}>
              Desarrollamos el diseño de la página web desde cero, cubriendo todas sus necesidades y <br />
              representando la personalidad de la universidad. <br />
              La universidad acudió a nosotros para actualizar y mejorar su página web, <br />
              pues la anterior además de ser una plantilla prediseñada, <br />
              tenía varios errores de funcionalidad y un diseño poco atractivo. <br /><br />
              Las necesidades de la universidad exigen hacer cambios periódicamente a la página <br />
              para crear una sensación dinámica y fresca, y para que no dependieran de un tercero, <br />
              desarrollamos un perfil administrativo que les permite actualizar secciones de la página <br />
              en el momento que ellos lo deseen.
            </p>
          ) :(
            <p className='texto' style={{textAlign:"center"}}>
              Desarrollamos el diseño de la página web desde cero, cubriendo todas sus necesidades y 
              representando la personalidad de la universidad. 
              La universidad acudió a nosotros para actualizar y mejorar su página web, 
              pues la anterior además de ser una plantilla prediseñada, 
              tenía varios errores de funcionalidad y un diseño poco atractivo. <br /><br />
              Las necesidades de la universidad exigen hacer cambios periódicamente a la página 
              para crear una sensación dinámica y fresca, y para que no dependieran de un tercero, 
              desarrollamos un perfil administrativo que les permite actualizar secciones de la página 
              en el momento que ellos lo deseen.
            </p>
          )}
        </div>

        {/* <img className="center-img dimensionar-imagen" alt="" src={filler}></img> */}
        <Desktop images={{desktop: "caavDesktop", laptop:"caavLaptop", movil: "caavMovil"}} />

        <div className='container'>
          <GaleriaCAAV/>
        </div>

        <div className='dimensionar-imagen-caav'>
          <img className="center-img" alt="" src={caav2}></img>
        </div>

        <div style={{display:"flex", justifyContent:"center", marginBottom:"50px"}}>
          <div className='btn_1'>
            <a href="#portafolioSofwareOver" style={{color:"#fff"}}>
              <p>
                Ver más del portafolio
              </p>
            </a>
          </div>
        </div>
        
      </Fragment>
    );
}

export default CAAV;
